<script>
import Container from "%/dynamic-component-editor/standard-elements/layouts/Container.vue";
import DynamicElementWithContext from "%/dynamic-component-editor/mixins/dynamic-element-with-context-mixin";
import ContextBindings from "%/dynamic-component-editor/options/context-bindings";
import ActionTrigger from "%/dynamic-component-editor/options/action-trigger";
import StopPropagation from "%/dynamic-component-editor/options/stop-propagation";
import LayoutPositionOptions from "%/dynamic-component-editor/bundles/layout-position-options";
import SpacingOptions from "%/dynamic-component-editor/bundles/spacing-options";
import AppearanceOptions from "%/dynamic-component-editor/bundles/appearance-options";
import BackgroundOptions from "%/dynamic-component-editor/bundles/background-options";
import PositioningOptions from "%/dynamic-component-editor/bundles/positioning-options";
import AnimationEffectsOptions from "%/dynamic-component-editor/bundles/animation-effects-options";
import EffectsOptions from "%/dynamic-component-editor/bundles/effects-options";

export default {
  name: "EntityActionContainer",
  extends: Container,
  mixins: [DynamicElementWithContext],
  elementPanelSettings: {
    alias: "Action Container",
    displayName: "Action",
    displayIcon: "mdi:gesture-tap",
    tags: ["container", "action", "row", "tap"],
  },
  options: [
    ContextBindings,
    ActionTrigger,
    StopPropagation,
  ],
  optionBundles: [
    PositioningOptions,
    new LayoutPositionOptions({
      "default.static-layout-direction": "horizontal",
    }),
    SpacingOptions,
    new AppearanceOptions({}, {
      "border-radius": false,
    }),
    BackgroundOptions,
    AnimationEffectsOptions,
    new EffectsOptions({}, {
      "text-shadow": true,
    }),
  ],
};
</script>
